// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 691) return "static/chunks/691-b41a244d77b89d19.js";
	if (chunkId === 725) return "static/chunks/725-2ea0051d82b8033b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8":"8b20211944ecee4d","683":"4b70e59f0be707ae"}[chunkId] + ".js";
};